import React from "react";
import { Row, Col, Button } from 'antd';
import Span from "../generic/span/span";
import Title from "../generic/title/title";
import InputRut from "../generic/input/input-rut";
import RadioButtonComponent from "../generic/radio/radio-button";
import { valNumero, valRut } from "../generic/utils/utils";
import InputNumerico from "../generic/input/input-numerico";

export default class ConsultaReclamo extends React.Component {

    constructor(props) {
        super();
        this.state = {
            form: {
                reclamo: {
                    solicitante: {
                        rut: null,
                        dv: null,
                    },
                    solicitud: {
                        tipo_consulta: 0,
                        numero: null,
                        empresa: props.linea,
                    }
                },
                alerta: {
                    mensaje: {
                        solicitante: {
                            rut: '',
                            rut_generico: props.textos.validations.rut.message_1
                        },
                        solicitud: {
                            numero: '',
                            numero_generico: props.textos.validations.solicitud.message
                        }
                    },
                    estado: {
                        solicitante: {
                            rut: false,
                        },
                        solicitud: {
                            numero: false,
                        }
                    },
                },
                textos: props.textos.CONSULTA_RECLAMO,
            },
        }
    }


    validaRadioBtn = (event) => {

        let formValue = this.state.form

        formValue.reclamo.solicitante.rut = null;
        formValue.reclamo.solicitante.dv = null;
        formValue.reclamo.solicitud.numero = null;

        if (event.target.value === 0) {
            formValue.reclamo.solicitud.tipo_consulta = 0;
            formValue.alerta.estado.solicitud.numero = true;
            formValue.alerta.estado.solicitante.rut = false;
            formValue.alerta.mensaje.solicitud.numero = formValue.alerta.mensaje.solicitud.numero_generico;
        } else {
            formValue.reclamo.solicitud.tipo_consulta = 1;
            formValue.alerta.estado.solicitud.numero = false;
            formValue.alerta.estado.solicitante.rut = true;
            formValue.alerta.mensaje.solicitante.rut = formValue.alerta.mensaje.solicitante.rut_generico;
        }

        this.setState({ form: formValue });
    }

    validaRut = async (event) => {

        let data = await valRut(event);
        let formValue = this.state.form;

        formValue.reclamo.solicitante.rut = data.rut;
        formValue.reclamo.solicitante.dv = data.dv;
        formValue.alerta.estado.solicitante.rut = data.activeSpan;
        formValue.alerta.mensaje.solicitante.rut = data.txtSpan;

        this.setState({ form: formValue })

    }

    validaSolicitud = async (event) => {

        let data = await valNumero(event);
        let formValue = this.state.form;

        formValue.reclamo.solicitud.numero = data.numero;
        formValue.alerta.estado.solicitud.numero = data.activeSpan;
        formValue.alerta.mensaje.solicitud.numero = data.txtSpan;

        this.setState({ form: formValue });
    }

    handleOk = async (e) => {

        let formulario = this.state.form;

        if(formulario.reclamo.solicitante.rut === null && formulario.reclamo.solicitud.numero === null) {
            if(formulario.reclamo.solicitud.tipo_consulta === 0) {
                formulario.alerta.estado.solicitante.rut = true;
                formulario.alerta.estado.solicitud.numero = true;
                formulario.alerta.mensaje.solicitud.numero = formulario.alerta.mensaje.solicitud.numero_generico;
            } else {
                formulario.alerta.estado.solicitante.rut = true;
                formulario.alerta.estado.solicitud.numero = true;
                formulario.alerta.mensaje.solicitante.rut = formulario.alerta.mensaje.solicitante.rut_generico;
            }
        }

        if (!formulario.alerta.estado.solicitante.rut || !formulario.alerta.estado.solicitud.numero) {
            this.props.onComplete(formulario);
        } else {
            this.setState({ formulario });
        }
    }

    render() {
        return (
            <div className="box-content">
                <Title h={1} text={this.state.form.textos.HEADER.TITULOS.TIT_CONSULTA} />
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.TITULOS.TIT_DEBES_SABER} /></p></div>
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_1} /></p></div>
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_2} /></p></div>
                <div className="texto-justify" style={{ marginBottom: '7%' }}><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_3} /></p></div>
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.TITULOS.TIT_BUSQUEDA_POR} /></p></div>

                <Row className="transaction-row">
                    <Row className="transaction-radio-row">
                        <Col flex="1 1 30px">
                            <RadioButtonComponent onChange={this.validaRadioBtn} disabled={false} value={this.state.form.reclamo.solicitud.tipo_consulta === 0 ? 0 : 1} textos={this.state.form.textos} />
                        </Col>
                    </Row>
                    <Row className="transaction-radio-row">
                        <Col flex="1 1 30px">
                            {
                                this.state.form.reclamo.solicitud.tipo_consulta === 1 ?
                                    <>
                                        <InputRut id="rutsoli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITANTE.RUT} value={''} max={13} onChange={this.validaRut} />
                                        {this.state.form.alerta.estado.solicitante.rut ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitante.rut} /></div> : <div></div>}
                                    </> :
                                    <>
                                        <InputNumerico id="soli" placeholder={this.state.form.textos.BODY.INPUT.PLACEHOLDER.SOLICITUD.NUMERO} value={''} max={12} onChange={this.validaSolicitud} />
                                        {this.state.form.alerta.estado.solicitud.numero ? <div className="informacion label"> <Span text={this.state.form.alerta.mensaje.solicitud.numero} /></div> : <div></div>}
                                    </>
                            }
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <Button color="success" onClick={() => this.handleOk(this.state.form)}>{this.state.form.textos.BODY.BUTTON.ENVIAR}</Button>{' '}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                            </div>
                        </Col>
                    </Row>
                </Row>

            </div>
        );
    }
}